<template>
    <div class="score-list">
        <div v-if="sumCount != 0 " class="global " >
            <div class="year_trem" v-if="this.type != 'teacher'">
                <ul >
                    <li @click="yearClick" ><i class="iconfont icon-xia" :class="!popupVisible ? 'icon-xia' : 'icon-shang'"  >{{currYearName ? currYearName : "学年"}}</i></li>
                    <li @click="termClick" ><i class="iconfont icon-xia" :class="!popupVisible1 ? 'icon-xia' : 'icon-shang'">{{currTermName ? currTermName : "学期"}}</i></li>
                </ul>
            </div>
            <div class="tirm_box" v-if="sumCount != 0 && this.type != 'teacher'">

            </div>
            <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
                <ul>
                    <li v-for="item in list" :key="item.id" >
                        <router-link :to="{ name: 'Score-' + type, query:{ examID: item.examID, examType: item.type, type: type } }" v-if="type == 'student'">
                            <div class="score-item flex flex-align-center">
                                <div class="list-info flex-1">
                                    <h2><span class="tip">{{item.title}}</span>{{item.examName}}</h2>
                                    <p>
                                        <span>学年：{{item.year}}</span>
                                        <span>学期：{{item.termText}}</span>                    
                                    </p>
                                </div>
                                <div class="list-date">
                                    <p>{{item.startDate}}</p>
                                    <P>{{item.endDate}}</P>
                                </div>
                            </div>
                        </router-link>

                        <router-link :to="{ name: 'TScoreDetail', query:{ examID: item.examId, examType: item.type, type: type, classId: classId, grade: grade, examName: item.examName } }" v-else>
                            <div class="score-item flex flex-align-center">
                                <div class="list-info flex-1">
                                    <h2><span class="tip">{{item.title}}</span>{{item.examName}}</h2>
                                    <p>
                                        <span>学年：{{item.year}}</span>
                                        <span>学期：{{item.termText}}</span>                    
                                    </p>
                                </div>
                                <div class="list-date">
                                    <p>{{item.startDate}}</p>
                                    <P>{{item.endDate}}</P>
                                </div>
                            </div>
                        </router-link>

                    </li>
                </ul>
                <div slot="top" class="mint-loadmore-top">
                    <span v-show="topStatus !== 'loading'" :class="{ 'rotate': topStatus === 'drop' }">↓</span>
                </div>
            </mt-loadmore>
        </div>
        <div v-else class="no-exam">暂无往期考试!</div>
        <!-- 底部返回上一页 返回首页信息放这里 -->
        <bottom></bottom>
        <!-- 学年 -->
        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="assess-filter-type">
            <ul class="history-list list-gap" >
                <li v-for="value in yearList" @click="clickYear(value.codeName,value.codeValue)">{{value.codeName}}</li>
            </ul>
        </mt-popup>
        <!-- 学期 -->
        <mt-popup
            v-model="popupVisible1"
            position="bottom"
            class="assess-filter-type">
            <ul class="history-list list-gap" >
               <li v-for="value in termList" @click="clickTerm(value.codeName,value.codeValue)">{{value.codeName}}</li>
            </ul>
        </mt-popup>
    </div>

</template>
<style lang="less">
.score-list{
    background-color: #f2f3f8;
    .mint-loadmore{
        background-color: white;
        
    }
    .tirm_box{
        height: 50px;
        margin-bottom: 15px;
    }
}
    .year_trem{
        width: 100%;
        height: 50px;
        background-color: white;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        ul{
            overflow: hidden;
            li{
                width: 49.8%;
                text-align: center;
                float: left;
                line-height: 50px;
            }
        }
    }
</style>

<script>
import Bottom from '../bottom.vue'
import Vue from 'vue'
import { Loadmore } from 'mint-ui';
Vue.component(Loadmore.name, Loadmore);

export default {
    data() {
        return {
            type: this.$route.query.type,
            classId: this.$route.query.classId,
            grade: this.$route.query.grade,
            page: 0,
            list: [],
            allLoaded: false,
            topStatus: '',
            sumCount: 0,
            addList: 0,
            listCount: 0,
            yearList: [],
            termList: [],
            currYear: null,
            currTerm: null,
            currYearName : null,
            currTermName: null,
            popupVisible: false,
            popupVisible1: false,
        }
    },
    components: { Bottom },
    mounted() {
        this.$nextTick( () => {
            this.$http.post("/api/mobile/exam/getYearAndTerm").then(suss=>{
                this.yearList = suss.data.yearList;
                this.termList = suss.data.termList;
                this.currYear = suss.data.defaultYear;
                this.currTerm = suss.data.defaultTerm;
                for(var i = 0; i<this.yearList.length; i++){
                    if(this.currYear.indexOf(this.yearList[i].codeValue != -1)){
                        this.currYearName = this.yearList[i].codeName;
                    }
                }
                this.currTermName = this.currTerm == "1" ? '第一学期' : '第二学期';
            
            }).then(sussces=>{
                this.$http.get('/api/mobile/exam/getExamListStuCount', {params: {
                    type: this.type
                } })
                .then(res => {
                    this.sumCount = res.data.data.sumCount;
                });
            })  
        });
    },
    methods: {
        // 学年
        clickYear(name,value) {
            
            this.currYear = value;
            this.currYearName = name;
            this.popupVisible = false;
            this.list = [];
            this.page = 0;
            this.loadBottom();
            
            
        },
        // 学期
        clickTerm(name, value) {
            this.currTerm = value;
            this.currTermName = name;
            this.popupVisible1 = false;
            this.list = [];
            this.page = 0;
            this.loadBottom();
            
        },
        // 学年学期弹出框
        termClick() {
            this.popupVisible1= true;
        },
        yearClick() {
            this.popupVisible= true;
        },
        //下拉滚动加载数据
        loadBottom() {
            this.$http.get('/api/mobile/exam/queryExamList', {params: {
                type: this.type,
                classId: this.classId,
                page: this.page,
                year: this.currYear,
                term: this.currTerm
            } })
            .then(res => {
                this.allLoaded = false;
                _.each(res.data.data, list => {
                    //判断是学校考试还是区县考试
                    if(list.type == 'end') {
                        list.title = '(区统考)';
                    } else {
                        list.title = '';
                    }
                    //设置学年学期显示
                    let year = Number(list.schoolYear);
                    list.year = year + '-' + (year+1);
                    if(list.term == '1') {
                        list.termText = '第一学期';
                    } else {
                        list.termText = '第二学期';
                    }
                    
                    this.list.push (list);

                });
                
                //this.allLoaded = true;// 若数据已全部获取完毕
                if(this.page == 0) {
                    this.listCount = res.data.listCount;
                }
                //this.addList = this.addList + res.data.data.length;
                this.page ++;
                if(this.listCount <= this.page*10) {
                    this.allLoaded = true;
                }
                this.$refs.loadmore.onBottomLoaded();
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/score/score-list.vue